import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const InvestorRelationsPage = () => {
  const [publications, setPublications] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('');

  useEffect(() => {
    const fetchPublications = async () => {
      try {
        setLoading(true);
        const response = await fetch('/api/publications');
        const data = await response.json();

        if (data.message === 'Publications fetched successfully') {
          setPublications(data.publications);
          // Set first available tab as active
          const firstTab = Object.keys(data.publications)[0];
          setActiveTab(firstTab);
        } else {
          toast.error('Failed to fetch publications');
        }
      } catch (error) {
        console.error('Error fetching publications:', error);
        toast.error('Failed to fetch publications');
      } finally {
        setLoading(false);
      }
    };

    fetchPublications();
  }, []);

  const getCount = (type) => {
    return publications[type]?.length || 0;
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold">Reports</h1>
        </div>

        {/* Filter Tabs */}
        <div className="flex justify-center mb-8">
          <ul className="nav nav-pills flex space-x-4" role="tablist">
            {Object.keys(publications).map((type) => (
              <li key={type} className="nav-item" role="presentation">
                <button
                  className={`nav-link px-4 py-2 rounded-lg ${
                    activeTab === type ? 'bg-[#1A8D32] text-white' : 'bg-gray-200 text-gray-700 hover:bg-[#1E4C9A] hover:text-white'
                  }`}
                  onClick={() => setActiveTab(type)}
                >
                  {type} ({getCount(type)})
                </button>
              </li>
            ))}
          </ul>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#1E4C9A]"></div>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      S.N
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Title
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Description
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Date
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {publications[activeTab]?.map((pub, index) => (
                    <tr key={pub.publication_id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {index + 1}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {pub.title}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500">
                        {pub.description || '-'}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {pub.published_date ? new Date(pub.published_date).toLocaleDateString() : '-'}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        <a
                          href={pub.file_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center px-3 py-1 border border-transparent text-sm font-medium rounded-md text-white bg-[#1A8D32] hover:bg-[#1E4C9A]"
                        >
                          View Document
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {(!publications[activeTab] || publications[activeTab].length === 0) && (
              <div className="text-center py-8">
                <p className="text-gray-500">No publications available in this category.</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default InvestorRelationsPage; 